import { instance as axios } from "@/store/_AXIOS";
import {_TOKEN, _DECODE} from "@/store/_JWT"

const TABLE = '/utilizador_colheita/';

// initial state
const state = {
    data: []
}

// getters
const getters = {
    getAll:(state)=>{
        return state.data
    },
}

// actions
const actions = {

    get({ commit }, id) {
        return axios
            .post(TABLE+'params/'+_TOKEN({id_colheita: id}))
            .then(res => {
                _DECODE(res.data.data).then((r)=>{
                    if(r) commit('setData', r)
                    else commit('setData', null)
                });
            })
            .catch(err => {
                commit('setData', null)
            });
    },

    insert({ dispatch, rootState }, params) {
        
        return axios
            .post(TABLE+_TOKEN(params))
            .then(res => {
                return !res.data.errors
            })
            .catch(err => {
                return false;
            });
    },

    update({ dispatch, rootState }, params) {
        return axios
            .put(TABLE+_TOKEN(params))
            .then(res => {
                return !res.data.errors;
            })
            .catch(err => {
                return false;
            });
    },

    delete({ dispatch, rootState }, params) {
        return axios
            .delete(TABLE+_TOKEN(params))
            .then(res => {
                return !res.data.errors
            })
            .catch(err => {
                return false;
            });
    },

}

// mutations
const mutations = {
    setData(state, data) {
        state.data = data ? data : [];
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}